module.exports = __webpack_public_path__ + "static/media/Vortex-2WD-OV-5200.4d9439bf.png";